import { FETCH_MESSAGES, LOG_OUT_USER } from "../../actions/actionTypes";

const fetchMessagesSummaryReducer = (summary, payload) => {
    summary = [];
    for(let s of payload){
        summary.push(s);
    }
    return summary;
}


const messagesSummaryReducer = (state=[], action) => {
    let summary = state;
    if (action && action.summary && !action.payload.errors){
        switch(action.type){
            case FETCH_MESSAGES:
                return fetchMessagesSummaryReducer(summary, action.summary);
            case LOG_OUT_USER:
                return [];
            default:
                return summary;
        }
    }
    return summary;
}

export default messagesSummaryReducer;